export const CURRENT_REGION_URL_KEY = 'regionUrl';
